import { Reader } from './bytes';

export interface FontGlyph {
  code: number;
  width: number; // advance
  height: number;
  frame: number; // DC6 frame index
}

export interface FontTable {
  lineHeight: number;
  capHeight: number;
  glyphs: Map<number, FontGlyph>;
}

/** Font `.tbl` ("Woo!" header): per-character advance and DC6 frame, paired with a `.dc6`. */
export function decodeFontTable(data: Uint8Array): FontTable {
  const r = new Reader(data);
  const magic = r.fixedStr(4);
  if (magic !== 'Woo!') throw new Error('font tbl: bad magic');
  r.skip(6);
  const lineHeight = r.u8();
  const capHeight = r.u8();
  const glyphs = new Map<number, FontGlyph>();
  while (r.remaining >= 14) {
    const code = r.u16();
    r.skip(1);
    const width = r.u8();
    const height = r.u8();
    r.skip(3);
    const frame = r.u16();
    r.skip(4);
    glyphs.set(code, { code, width, height, frame });
  }
  return { lineHeight, capHeight, glyphs };
}
